import { IApiResponseError } from '../../../types/api';
import { RootState } from '../..';

export interface IApiErrorPayload {
  message?: string;
  errors?: IApiResponseError[];
}

const GENERIC_ERROR_MESSAGE =
  'An error occurred, this might be a temporary error. Please try again';

export const getApiErrorMessage = (
  payload: unknown,
  fallback?: string,
): string => {
  const body = (payload ?? {}) as IApiErrorPayload;

  if (body.errors?.length) {
    const flat = body.errors
      .map((e) => e?.message)
      .filter((m): m is string => !!m);
    if (flat.length) return flat.join('\n');
  }

  if (body.message) {
    if (body.message.toLowerCase() === 'your data is invalid') {
      return fallback ?? GENERIC_ERROR_MESSAGE;
    }
    return body.message;
  }

  return fallback ?? GENERIC_ERROR_MESSAGE;
};

export const getSavingsBusinessId = (state: RootState): string | null =>
  localStorage.getItem('businessId') ||
  state.auth.value?.data?.user?.businesses?.[0]?.id ||
  null;

export const getSavingsAuthConfig = (
  state: RootState,
  extraHeaders: Record<string, string> = {},
) => {
  const accessToken = state.auth.value?.data?.token?.accessToken;
  return {
    headers: {
      Authorization: `Token ${accessToken}`,
      'X-Business-Id': getSavingsBusinessId(state),
      ...extraHeaders,
    },
  };
};
